import { render } from "./OfficeCard.vue?vue&type=template&id=467530b0&scoped=true"
import script from "./OfficeCard.vue?vue&type=script&lang=js"
export * from "./OfficeCard.vue?vue&type=script&lang=js"

import "./OfficeCard.vue?vue&type=style&index=0&id=467530b0&lang=scss&scoped=true"

import exportComponent from "/var/www/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-467530b0"]])

export default __exports__